export enum VerificationStatusEnum {
  New = 10,
  Verified = 1,
  Blocked = 2,
  Submitted = 3,
  Verifying = 4,
}
